import { render, staticRenderFns } from "./DialogAtualizacaoDaVersao.vue?vue&type=template&id=7fabf531&scoped=true&"
import script from "./DialogAtualizacaoDaVersao.vue?vue&type=script&lang=js&"
export * from "./DialogAtualizacaoDaVersao.vue?vue&type=script&lang=js&"
import style0 from "./DialogAtualizacaoDaVersao.vue?vue&type=style&index=0&id=7fabf531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fabf531",
  null
  
)

export default component.exports